import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const Headline = ({ children, level, hideOverflow, className, qaId }) => {
  const headlineClasses = classNames({
    [`uni-headline--${level}`]: level,
    'u-text-overflow': hideOverflow,
    [className]: className,
  });

  let headlineEl;
  if (level === '1') {
    headlineEl = (
      <h2 className={headlineClasses} data-qa-id={qaId}>
        {children}
      </h2>
    );
  } else if (level === '2') {
    headlineEl = (
      <h2 className={headlineClasses} data-qa-id={qaId}>
        {children}
      </h2>
    );
  } else if (level === '3') {
    headlineEl = (
      <h3 className={headlineClasses} data-qa-id={qaId}>
        {children}
      </h3>
    );
  }

  return headlineEl;
};

Headline.propTypes = {
  children: PropTypes.string,
  level: PropTypes.oneOf(['1', '2', '3']),
  hideOverflow: PropTypes.bool,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

Headline.defaultProps = {
  level: '1',
  className: '',
};

export default Headline;



// WEBPACK FOOTER //
// ./src/type/headline/index.jsx